export default __webpack_public_path__ + "35c0cf433b6a6489815812762f2d24f3.svg";